module.exports = __webpack_public_path__ + "static/media/header_whatsapp_icon.4079d980.svg";